import styled from 'styled-components';

type Props = { children: React.ReactNode };

const CategoriesListItem = styled.ul<Props>`
  margin: 0;
  padding: 0;
`;

export default CategoriesListItem;
